import React from 'react';

/**
 * Small pill badge for nav items and icons.
 * @param {'amber'|'teal'|'rose'} tone
 */
const CountBadge = ({
    value,
    className = '',
    tone = 'amber',
    position = 'inline',
}) => {
    if (value === undefined || value === null || Number(value) <= 0) return null;
    const display = Number(value) > 99 ? '99+' : value;

    const toneClass = {
        amber: 'border-amber-200 bg-amber-50 text-amber-900 dark:border-amber-900/50 dark:bg-amber-950/50 dark:text-amber-200',
        teal: 'border-teal-200 bg-teal-50 text-teal-900 dark:border-teal-900/50 dark:bg-teal-950/50 dark:text-teal-200',
        rose: 'border-rose-200 bg-rose-50 text-rose-900 dark:border-rose-900/50 dark:bg-rose-950/50 dark:text-rose-200',
    }[tone];

    const positionClass =
        position === 'absolute'
            ? 'absolute -right-0.5 -top-0.5 h-[18px] min-w-[18px] px-1 text-[9px]'
            : 'ml-auto h-5 min-w-[20px] px-1.5 text-[10px]';

    return (
        <span
            className={`inline-flex items-center justify-center rounded-full border font-semibold tabular-nums ${toneClass} ${positionClass} ${className}`}
        >
            {display}
        </span>
    );
};

export default CountBadge;
